import React from 'react';
import { Button } from '../../../../../components/ui/Button';

interface MappingStepProps {
    headerList: string[];
    rawData: Record<string, any>[];
    mapping: Record<string, string>;
    onMappingChange: (header: string, field: string) => void;
    onBack: () => void;
    onNext: () => void;
}

const SYSTEM_FIELDS = [
    { value: 'ignore', label: 'Ignorar esta coluna' },
    { value: 'name', label: 'Nome Completo' },
    { value: 'whatsapp', label: 'WhatsApp / Celular' },
    { value: 'email', label: 'E-mail' },
    { value: 'phone', label: 'Telefone Fixo' },
];

export const MappingStep: React.FC<MappingStepProps> = ({
    headerList,
    rawData,
    mapping,
    onMappingChange,
    onBack,
    onNext
}) => {
    return (
        <div className="space-y-s6">
            <aside
                className="rounded-lg border border-info/20 bg-info-bg p-s4 text-sm text-info-text"
                aria-label="Instrução de mapeamento"
            >
                Verifique se o mapeamento abaixo está correto. Para ignorar uma coluna, selecione &quot;Ignorar&quot;.
            </aside>

            <div className="max-h-[400px] overflow-auto rounded-lg border border-border">
                <table className="w-full text-left text-sm">
                    <thead className="sticky top-0 z-10 bg-surface-subtle">
                        <tr>
                            <th className="border-b border-border p-s3 text-xs font-semibold uppercase tracking-wide text-muted">
                                Coluna do Arquivo
                            </th>
                            <th className="border-b border-border p-s3 text-xs font-semibold uppercase tracking-wide text-muted">
                                Exemplo (Linha 1)
                            </th>
                            <th className="w-1/3 border-b border-border p-s3 text-xs font-semibold uppercase tracking-wide text-muted">
                                Importar como
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-border">
                        {headerList.map((header, index) => (
                            <tr key={header} className="transition-colors hover:bg-surface-subtle">
                                <td className="p-s3 font-medium text-default">{header}</td>
                                <td className="max-w-[200px] truncate p-s3 text-muted">
                                    {rawData[0]?.[header] || '—'}
                                </td>
                                <td className="p-s3">
                                    <select
                                        id={`import-mapping-${index}`}
                                        name={`import-mapping-${index}`}
                                        className="input w-full"
                                        value={mapping[header] || 'ignore'}
                                        onChange={(e) => onMappingChange(header, e.target.value)}
                                        aria-label={`Mapear coluna ${header}`}
                                    >
                                        {SYSTEM_FIELDS.map(field => (
                                            <option key={field.value} value={field.value}>
                                                {field.label}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <footer className="flex flex-col-reverse gap-s3 border-t border-border pt-s4 sm:flex-row sm:justify-end">
                <Button type="button" variant="secondary" onClick={onBack} className="min-h-11 touch-manipulation sm:min-h-0">
                    Voltar
                </Button>
                <Button type="button" onClick={onNext} className="min-h-11 touch-manipulation sm:min-h-0">
                    Confirmar e Importar
                </Button>
            </footer>
        </div>
    );
};
